import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { getNewsRPMInstanceByCode } from "#root/schema/platform/newsrpm-instance";

import PageLayout from "./layout";

export default function ({ instanceId }): ReactNode {
  const [statusMessage] = useData(async () => {
    const response = await getNewsRPMInstanceByCode(instanceId).fetch("status", {
      method: "GET",
    });
    return response.text();
  }, []);

  return (
    <PageLayout title="NewsRPM - Manage Instance">
      <section>
        <h2>Instance Health</h2>
        <div>{statusMessage}</div>
      </section>
    </PageLayout>
  );
}
